import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import * as SessionManager from "../../../../managers/session/SessionManager";
import * as SessionKeys from "../../../../managers/session/SessionKeys";
import { USER_ROUTES } from "../../../../routes/ScreenRoutes";
import { DriverHomeStyles, ManageTripStyles } from "../../../styles";
import { Link, Redirect } from "react-router-dom";
import {
  Avatar,
  Icon,
  IconButton,
  Grid,
  Badge,
  Menu,
  List,
  Toolbar,
  MenuItem,
  ListItem,
  Hidden,
  AppBar,
  Drawer,
  Divider,
  ListItemText,
  CssBaseline,
  Typography,
  ListItemIcon
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { DRIVER_HERO_IMAGE } from "../../../../values/Icons";
import { PADDING, MARGIN } from "../../../../values/Typography";
import { TAXI_IMAGE_URL } from "../../../../managers/api/ApiEndPoints";
import EventBus from "eventing-bus";
import * as LanguageManager from "../../../../managers/language/LanguageManager";

const drawerWidth = 240;

const UserBookingStyles = theme => ({
  root: {
    display: "flex"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    backgroundColor: "#bebebe",
    marginLeft: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      display: "none"
    }
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 1
  },
  barTitle: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem"
    }
  }
});

class UserLayout extends Component {
  state = {
    anchorEl: null,
    name: "",
    phoneNumber: "",
    email: "",
    profilePic: "",
    isLogout: false,
    mobileOpen: false
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  // handleLogout=()=>{
  //   SessionManager.particularKey(SessionKeys.ACCESS_TOKEN);
  //   // setTimeout(()=>{this.setState({anchorEl:null,isLogout:true})},500)
  //   setTimeout(()=>{this.props.history.replace('/')},500)

  // }

  //  redirectToHome(){
  //         // return <Redirect to="/driver/manage_vehicles" />;
  //         // await SessionManager.particularKey(SessionKeys.USER_ACCESS_TOKEN);
  //          setTimeout(()=>{return <Redirect to={{pathname: '/'}} />},500)
  //   }

  // redirectToHome = () => {
  //   if (this.state.isLogout) {
  //     console.log("f$F4F4F$")
  //     SessionManager.particularKey(SessionKeys.ACCESS_TOKEN);
  //       //  setTimeout(()=>{},500)
  //   }
  // };

  componentDidMount() {
    this.updateData();
  }

  updateData = () => {
    let sessionData = JSON.parse(
      SessionManager.getSessionData(SessionKeys.USER_DATA)
    );

    if (sessionData) {
      this.setState({
        referalCode: sessionData.ReferralCode,
        name: sessionData.first_name + sessionData.last_name, //sessionData.first_name + sessionData.last_name,
        phoneNumber: sessionData.phone_code + sessionData.UserPhone, //sessionData.phone_code + sessionData.UserPhone,
        email: sessionData.email, //sessionData.email,
        profilePic: sessionData.UserProfileImage //sessionData.UserProfileImage
      });
    }
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  componentWillMount() {
    EventBus.on("REFRESH_SESSION", data => {
      this.updateData();
    });
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const { classes, theme } = this.props;
    const { anchorEl } = this.state;

    // if(this.state.isLogout){
    //   return <Redirect to={{pathname: '/'}} />
    // }
    return (
      <div className={classes.root} style={{ zIndex: 10 }}>
        <CssBaseline />

        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography color="inherit" noWrap className={classes.barTitle}>
              {LanguageManager.Strings.WELCOME_LABEL} {this.state.name}
            </Typography>
          </Toolbar>
        </AppBar>
        {/* <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper
          }}
          anchor="left"
        >
          <Grid container className={classes.toolbar}>
            <Grid
              item
              md={3}
              style={{
                padding: "2%",

                alignItems: "center"
              }}
            >
              <Avatar
                src={
                  !this.state.profilePic
                    ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAABPlBMVEX/wgD/////6L5ncHmKXEL53KTexJL/wwD/vwDm5ub/xQBDSVX/vgD/xwBlbndpcnvs7OyHWUN/ho2EVkTd3d6OlJn/7cKwtLj53KVdaneDUjmGVz3/4abPuo//+uz/4Zb/8Mn/7Lr44LeAU0X/9NVca3z/0VD//ff/5qhMU17/+OT/zTpaYmz/1Wf/4J7/xx5VXWf/3onlyqTcpByVZjyQY0mQYT64q5D/y0PAjCqtezPStJDytw3/2Hd4e4Ls06Wcc1eRhmJ0d3CemIiOjITUqjOyl022knPYt4jIt5XmrBbLlSWdbTrHkSikczeWmZaqq6O+v7lvdXCAfWnPqDelkFSLg2TDoT6ailx7f3uulU3cryqnqq42PUvS0cq6nEWknIrAn364hC6pgmSxfjHXoCG3r5zRw6jEt561jFyEFfheAAAT5UlEQVR4nL2d/V/TSLfAU9I2JTYp3Srb0go0pS3Ylne6CMWyLq5rQRBcXXn0uiLLs/f+///AnclLm7eZzJmZeH7ygxrON+d1zkwSJZO2dLtrzfXNnUGnt7Wla5qiafrWVq8z2Nlcb64td1P//UqK115ea+4MenqxWECihAX/sFjUe4Od9bXlFLVIi3BtfXCox4FFBf0r7XCwvpaSJmkQrm12NDa4IGZnMw1K2YTLzYFehMH5MIvaoCnbY6USPlvvKEDbRW2pdNafyVRKHmEX4wnRTSkRpLwcK4twdSBovBBkYbAqSTMphMsrW9yxR2Qsbq1ICUkJhGsnmmw8F1I7kZBchQnXOlLdM8RY6AgzChKu9oqp4TlS7AkGpBDhaoePT0O9qa5rrIyHQowChMg/OeB0wzCU0WQy2RuxIipCvspNuDwA8yHDaaOH55fDcrlcaT2H/NfCgDuvchJ2V6D5RTO00flRtlUpl7PZbHk4MUD/vVBY4WwC+AgXt4B8ujF6e1GpYDgs5f2RDrsAYtxa/GGEXaCDotjbuyxP8bAF4YCYccBjRg7CJqz91PTC+dCHhwm5ALGrNn8A4fIAViF0BfFlA9I6h8WgT4rwjAMlbOogA+r6w36IL1u+CADatdGV5PpR0JvpEp7AHNQYXQT9E0tlok/RnOK49/Bwfv7wsDcZaegHeFxFYzxJkfAZLIXqyvNWhC9bvtTt0qgXUG082i+3WpWptFrDy+8PI8WgWbOwBVohQwibEDxFMSYRB7VN+IBMV5i8PRoipHLkDqBmoLL/z97IoCWjZjqEOwwG1PSR9yfjPKo+lqGiPGC62L/0MCvZoz1KWBZ2UiDssnSh+ui7q5VeOIozIJL9f8pUuink8FwhMhY6zKWRlZApBI1J1m2njVGshzq6J+M5Usm+LRARmYORkXCVpUQbD63nTiEw9uI9FCaoPT8iIioa45qKjZApxxjnFdeExgPRgAC+1sX5iFo4mvII11naGONtpXxkOH9qCfNVst9H1JqBpLgpi3CFCRBZEBUC/KfnwoAoyxSM5AanuCKHkKVKKPpeBXfUGgYUddFK9lxh4FPYqkYyIVOjpo/szILyAnJWMb5y5TuL/VzE5BYukfCExUU15QITDg3krIIuWr4cJXWmfikmIiYRMrmoon+3DbdvGHuiFrzYm0xGqDNFHTjTIjLRURMIV9gAJw7X0JgIl0HUlqKLDfePnj9M9KRsaiMmpBs64SbbalcfOmDDwlBCoXdAMWn58u1IS4RMKBpUwiYb4Cy5XMgC9Dgrrf3noyR3LTZ5CVeZ+BRtNNNILqADWb6cUJdSSGgNHIXwGWNCM75L6NHokIiRqoxGacPJhN0tsAnTY2z9U6CacYu8mCITsu5K6MI9DItUhnu0AV2hAydkK4S42P8Avix21ec0K5LLIomwyTpz0s9/hAkx4RF1s4o4LCYQPmPkQ3lmP4UEGhXEl9SsErINgZAxy8zambQBz5N7uC0IIfvg1/j+I0zYemDYByCsM2IJmYMQ5ZnhDwCssG10xIdiHOEy+87QD3FSe0rOpE3ctk0cIWB7UHxBzyDeRkeiFAZshIz9tiOye+0YKV8yb8bF9eBRwi6ATxuBTFj3C/P/cuZbjBLt3qKEkC1snXEwWq8vLS0dnJ7ev359h+X16/vTA/QzJs4W+7GUOD+NEC5CNtAYagWGO7i/O961rLm5xZnMWdbu8d39AcJMuEIZsiVeiBxnCBOyrigc0ekNTR1pf3+8a4PNxQj+ubV7d1qnUu6DNv0jq4wwIdtgxhVNoQzW6kseXRxcANPafX1AhoQRRsY2IcJl2CYvuRou1e+PrSQ4HyWCzC4RrgU8uLFMJYSdlCGtK+pLBwC8KeTxaawhW+T9pzgJJ5sg4RrsKFB8oqkvne4C8TzI3TjGyh7MiIU1CmEHdCnFiKv3vHxTxvAFy9+Bx286ZMJV4Gk1I9p217PHc7x8NuPccTZkxvI+kLCwSiQEmjBmBrV0aonw2YzWfciMZUDJt6VDIlwFnvjVIjP8pdeifDbjXRARGohKcZVA2INdx9kzDADeyQBEiMcBR0ULfKBmvXjCNeih7XBXKseCDqLfiu7mOUCKa7GEwCiMlMP6qSzAEGL5AhiHgUicEQJroRJZ/tbH0gAR4r3PUYfQVOOviTNC2LFDmzBQ8OvSfNQWyx+IcMKTKOEy2BMU4x8/4dKuVMLFu5kRwckU5fnlCCFoUeESHvkJDyyZgMiIPkJwMvUtMaaEoHWhS3jpI5SZZ2zxRSK4b1N882GPEFrto4T3sglnbgovF76q7xHCn4BJnXBWMMqX8CQxXUS5hF2eJ+wChFnpXuojvODQrtANEK5zEaaaafxFf8hDuB4gBPczUULJ1SJQLoawZb4jHT8h+3ZhgDDNij+3+NrX1SgchO6GosLvpJEhhiWV0DqYXbnMY0PXTRV+J1X04DFEWWsnRxZ3lwQJXTe1CZe5ACOrp7olk9DvpHxe6swVbUL2HdEgYWgFLDUSLf8KkSvTuDumCm+5x4ThKcbSsTTEoAn3ufRzFhg2IZcLxEyi6qeyAP19N2fFR6J7hODxhSeRaaK0SPQXQ9yX8j2RaQ8zMOEm70sRgm0bdtNdSYRzB/7L8qwtsBQ2XUK+WqHE7OJLI9wNzBNBu8B+6biEnGEYM06U1ZsGZ23sRxXCojmE8BHU9AJKSuUiGIbZfa5ioTgDKYW3ZbMlGIh1acuLUKLhDEOncVO4qyEWfa/lB5S2ugh6KbeT2stgRHjIDYj8dGbE+r3QplNQ/LPE0LPfIDnEhBxjxJnoI8+dJFb7ueDmTIvbhPZQURFINFgO/6/sFQq549LppI233NuCUo0ikmgKvZXqeMn1UcljGq/m1w9yJwKETUTIeqA7RgbVaq7h3GzZM4xZssnnqpscw1yXcAcRDgQAc0j+sDU5kG1CN9ks/dHIiSAOECF0X3QqvapNWLV9Ser63hY7EuunDft3cDtaL6N0uWvNjg3ouKl0J3Wr/tIf9u/IVXntoHeVLu/SSXMAcw3sprKHpXNuINZzLiFvtikuK9yLw55LmMvXU8ikc/b6on7vEXJsjTmEawrnjAatTDzC6oH0WaktY3Tn7hru7+BdwxaaCnc5PPQIUSBKHNDMxJqFoQDhusK9wN+aEt7V5a3t/YTIN/Ie4Q6nloVNhb/ge4S4Iso8pDAjrB9MI4G3ahd2FO6C71WLXG6cRipFclA/9W5ilb/kK9xDGl8gHsjvaBzCe9FEgxKiwt3SKMqmVxHvZe+O2mIdLE1TKb8degq3+X314o+0CPOeCfmV3BIhVFZcxGoaBX/OmjkpvwkRn8DyEhUMFzGNYjE39vIMd6nAovNtW3ky8IyYBqHlXXxTREdNjFA5qaZHOOcC5kQCSZAPiVsU0yOs5kRmgTIYHStaKQBWpQCKeqniDGtScdNqTmh+MSUUyaWOHDaqqRAivuqOsAF0oXroyUkahFa1unko/rp3sYo/u8xgUzphY0c0xTiqifSlftFkAwJfJUqUnsDaIiCFFcmEAoPqgHT414fhK61KBVyVEj0KXh/KuldKUyphQ5JaaI3Pv7YMX0oqoSzXKmzyz9rC0pNK+LuEQo2lsM4/L42IxIKx+G/7Ped720NSaPLPvCPSkUh4ZtbUVzIQi2vKsixC4y9LGqFVU1Wz/Rf//v1Uisv8e09B0fRP7f9KO4rxGyJU1fZf4rrpXYH9Q79oyse2akoCtE0oCbEntAfsB3zfVtXa/0p6hPS/LqFa+yyKOBDbxw8CqmZJCuCcpXpimuDn8oJi7+OLF0RNswFlGXFmQnTFl4KETeHzNFhQknFv+QtLAqFVUmfS/iDkp4VnomeisBh/t6e3XEI6XfxWU/2IQqFon4kSOteGRP/cnuljWuImDACq5kuRUdKh6NlEBWeZG3OmT+1K+JUKZ2aAUG3/zm9E92yiWKoxPrX9+tQEj50s/hs0IUbkz6fu+VKhVBPwUexUt2ImtF6YEcJP3N2be0aY/5w3Jnwfuudiycbt12QZURM9q48A/2yH9TEFNqJifFQVqRgd0ect0E0KmxD7Kb8RrVLER23hNOL0eQv+JWI4CgX9dPFpnAmREf8WfGZG4IGLT3Eq1f7lRBwTCM33fBrqos+uIYnVyCxZXIBWnkCotidcT+fNnl3jndXor2KcVOUuGXkyIVfV9z1/yPkMqaJ/IGhUO+Pw0zyZ0HzJVRJnz5Dy1gvjZXzq41pHjSmEapunOfU9B8zZuGkjEqBa+wV60g0DUgg5Bm+BZ7n5nsePrRUeYR6GaANSCHkC0f88Pp+b6n9RCHMgRAeQTFj7FR6IgXcq8Lmp/juFsJEHILqAZEKOVBN6LwbXu02IqdQmrLIj5vNJhOoNWLvQu0343k8T29F4hDmsMguflWcgLEFb0/D7afjeMfQrlbCKdbaYPZROCG6+I+8Y4npPFJ0wZ+ue4Kk+AyJ5I48w8p4ornd9Ubz0Gz446ahNM+M4AJj/RRphzLu+OIaKlExjnmHCap7OGOLL58NTqJncAJuamPe1cbxzT/8PsVqYt84TWXkyoxXhy+eJFjRvgG/ajXnnHsdAilLx1ZJ7LHOq/NhKwkOJpk+6XO0j8GPzce9N5Hj3JWHxZN/0cS6EaGPaEgeXEIbt/8BsGPvuS/gwg9J5q7U3jThEusQN2lxCWOdNeH8pfK9UK5E0Umu/NXJgxBviHWvDFCO8gxZe9Y2P5GT6YvrQEDPiG3IYwhpv4nuEwZFIab3V2tPcVBgJz8hOCtuAIr4LGvw+b8oC0eemzGYkr6ffwz4eQH6fN9CIukEhVM1qzifkBDoVciYFbudT3skOqom68So68Par9UvDj1hNYKzmyJe6+Zz0AUS/UN+rz76I0rU/b9rkYmEbMRcSiq9Wcw1KT6q2339m+CKpC0j9NgLr9y00/dX7BL6IEcmGHGN/HlMvV2t/Yj7nRv++BdMSQzMmHxP5sIzDhBgyROk+OtUgJ1LXjObfTJ/PTfpGCct3ZnTlQztBHffGn0WMGGSd/blBWRlOGd+zvMall0kgTPxWEHLQEiWDBhHfUBF9Mma5ZbX274nRmPytoKRkoyufmBzU1SnOT+PMGd3bjpX2x4RoZPneE/WbXZrx+YbVgFjM22oyHkMQzm4ZKhxURJZvdlG+u4YjkN2AtkZnLITkNUX0nrU/UM5Hs313jeynxiuQAR3Eb4mh2AAAImm/JCYc1m/nEb5/qKE+G2ZARkQYILqi+orgqczfP4zdMdWUX8EGdBSKFn6/VJljcCqk89Hs37CMm0q5R0i5EL9RPHT8grhVQXGY2KMLkO+QRufDmvKSDljqU9b7Z6SM2nhD5Cht00IiDjFS66mEz8KASRYs9WmIt+M4T21UySFY2tgmXw8j/hlBhH0POBSKOkMMPqIgmurTKGLjaYkMuP0o4de1QxkV+k3n4He5adOKqU79RyYFMRKMjfFvNaIfIkDK/XKueBOY88O/y+3/tjptWOHTaoOGiDw17zNjI/cL2YAYcCMBEBnxV58Reb6tPltlBM/IktUyH1ERTXNWNhpviCnUAXzE8Bv9T2NEvlzJQph55l7A+MBWJ5Cf0n2r9sKJxsbTW7KDItlIuI4ns0cVdEKWSSDMrDomnLCW5FKSambtt3GjsXtG4ysxA/qO1q5SKGiETg+uk/dBI4KUoyf5mvmNkmBUx9cTruFDdI67xfXbjISZ9aKiMaUZn3ob6kw/M1rQI3yBf4I9nRnQHYUX16kMdMLMSiH+gCUNcZZvzCdffkpIGWbpy5fZsVmcY9gB8SBViw5mYISZnRGoHXUQ3TAyf15YmE9CfLyw8Ljk/ecNGCA+H00uhIyEmaewhttBdDy19Hh+fuFnKqH50wL6N0/sf2N7KGOSmcoovt2GEGbeEXeEKIhI0RKM0M6h9IoaI+18ov7JhHBEW9UNswQgLDkG9GcpFum/S1afgTBzDUR0rIECiplQde4KJARtwGsG7VkIoYhOSkQWYSb0rJ4CIBth5ittwR2H6AQjK+ELL3IhYppfmXRnI8w8JjzqQURUt10bftlWyaqXVIfwfx5tQw1olh6zqc5ImFm4BQ6McMKxCZH2fQQZAcA/6m+YNiHYQVEXv8CoOSthpnsFRVRNlxDHmEPpE7W/jaOv7+ZSKOAVebnESwiuGm7FdwidzLOxvd1Hsr29seH9rD+r+ABhqRIchPB8EyKMkxcchKw5Bk4IDUanHtb6GwS6jW3T37WxSu2WNQThhNhTAcq4FR8FnRNzQbw++gsVTmhCPJSDMPOVMkAiEKp23iyZTgA6wWi6yRVMWCtBPJSHMLNwxZxwQl1bIJO6AiXsX4E8lIsQkHCAq6dkgaUYfkJUGtmiUTKh2WcvgoKEyIxMSVUuYe2Ww4DchGi5weCqMglNk2khIZEQZ5wkveQRmhwZRpgwk5m/SrCjLELEN8+vpgAhWlM9odpRDqHZP2NcJ6VAiBhvKYwyCM0+Z4KRRYgYr0xSXhUnrJlXQvaTQoji8Ut0VC+DEN25dwLxJ5EQ5dXrWGcVIkTuec2dP/0ihTCDnbUfMSQ/oVnri7unK7IIUS/3FUVkQFVOQnSVs688/Vm8yCPMYG8NQPIQov9/Jcc7PZFKiGTh69WN569QQuSbN1cSreeIbEIs89dXJWQLE0Boon9fOruWkDojkgYhku789bufXjhzGgZC9aerr/OyjedKSoS2LHQX5heub/p95LbIpP4u1jZaDf3NLSZckBp4IUmT0JXu/Nfr63dXT25vb25KeJhxc3N7++Tq3c/XqdnNL/8P4fUMuE7fJlQAAAAASUVORK5CYII="
                    : TAXI_IMAGE_URL + this.state.profilePic
                }
                style={{ width: 60, height: 60, objectFit: "cover" }}
              />
            </Grid>
            <Grid
              item
              md={7}
              style={{
                display: "flex",
                alignItems: "left",
                flexDirection: "column",

                justifyContent: "center"
              }}
            >
              <Typography
                gutterBottom
                style={{
                  paddingTop: PADDING.SM,
                  fontWeight: "bold",
                  fontSize: "1rem"
                }}
              >
                {this.state.name}
              </Typography>

              <Typography variant="caption" gutterBottom>
                {this.state.email}
              </Typography>
            </Grid>

            <Grid item md={2}>
              <IconButton onClick={this.handleClick}>
                <Icon> more_horiz</Icon>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                  <Link
                    to={USER_ROUTES.PROFILE}
                    style={{ textDecoration: "none" }}>
                <MenuItem onClick={this.handleClose}>Profile</MenuItem>

                </Link>
                <Link
                  to={USER_ROUTES.MY_ACCOUNT}
                  style={{ textDecoration: "none" }}>
                  <MenuItem onClick={this.handleClose}>My account</MenuItem>
                </Link>

                <MenuItem onClick={()=>this.setState({isLogout:true},()=>this.props.logoutCallBack(this.state.isLogout))}>Logout</MenuItem>
                

              </Menu>
            </Grid>
          </Grid>
          <Divider />
          <Link to={{
                pathname: '/user_profile',
                state: {
                  fromNotifications: true
                }
              }}style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Profile" />
            </ListItem>
          </Link>
          <Link to={"/user_booking"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Book a ride" />
            </ListItem>
          </Link>
          <Link to={"/user_trips"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Trips History" />
            </ListItem>
          </Link>
          <Link to={"/fav_driver"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Favourite Driver" />
            </ListItem>
          </Link>
          <Link to={"/user_wallet"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Wallet" />
            </ListItem>
          </Link>

          <Divider />
        </Drawer> */}
        <nav className={classes.drawer}>
          <Hidden smUp implementation="css">
            <Drawer
              container={this.props.container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
            >
              <Grid container className={classes.toolbar}>
                <Grid
                  item
                  md={3}
                  style={{
                    padding: "2%",

                    alignItems: "center"
                  }}
                >
                  <Avatar
                    src={
                      !this.state.profilePic
                        ? "data:image/png;base64,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"
                        : TAXI_IMAGE_URL + this.state.profilePic
                    }
                    style={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                </Grid>
                <Grid
                  item
                  md={7}
                  style={{
                    display: "flex",
                    alignItems: "left",
                    flexDirection: "column",

                    justifyContent: "center"
                  }}
                >
                  <Typography
                    gutterBottom
                    style={{
                      paddingTop: PADDING.SM,
                      fontWeight: "bold",
                      fontSize: "1rem"
                    }}
                  >
                    {this.state.name}
                  </Typography>

                  <Typography variant="caption" gutterBottom>
                    {this.state.email}
                  </Typography>
                </Grid>

                <Grid item md={2}>
                  <IconButton onClick={this.handleClick}>
                    <Icon> more_horiz</Icon>
                  </IconButton>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                  >
                    <Link
                      to={USER_ROUTES.PROFILE}
                      style={{ textDecoration: "none" }}
                    >
                      <MenuItem onClick={this.handleClose}>
                        {LanguageManager.Strings.USER_MENU_OPTION1}
                      </MenuItem>
                    </Link>
                    {/* <Link
                      to={USER_ROUTES.MY_ACCOUNT}
                      style={{ textDecoration: "none" }}
                    >
                      <MenuItem onClick={this.handleClose}>
                        {LanguageManager.Strings.USER_MENU_OPTION2}
                      </MenuItem>
                    </Link> */}

                    <MenuItem
                      onClick={() =>
                        this.setState({ isLogout: true }, () =>
                          setTimeout(() => {
                            this.props.logoutCallBack(this.state.isLogout);
                          }, 1000)
                        )
                      }
                    >
                      {LanguageManager.Strings.USER_MENU_OPTION3}
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
              <Divider />
              <Link
                to={{
                  pathname: "/user_profile",
                  state: {
                    fromNotifications: true
                  }
                }}
                style={{ textDecoration: "none" }}
              >
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> person</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION1}
                  />
                </ListItem>
              </Link>
              <Link to={"/user_booking"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> local_taxi</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION2}
                  />
                </ListItem>
              </Link>
              <Link to={"/user_trips"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> history </Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION3}
                  />
                </ListItem>
              </Link>
              {/* <Link to={"/fav_driver"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Favourite Driver" />
            </ListItem>
          </Link> */}
              <Link to={"/user_wallet"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> account_balance_wallet </Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION4}
                  />
                </ListItem>
              </Link>

              <Divider />
              <ListItem button key="2">
                <Typography>Refer and Earn : </Typography>
                <Typography style={{ fontWeight: 600, color: "green" }}>
                  {" "}
                  {this.state.referalCode}
                </Typography>
              </ListItem>
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper
              }}
              variant="permanent"
              open
            >
              <Grid container className={classes.toolbar}>
                <Grid
                  item
                  md={3}
                  style={{
                    padding: "2%",

                    alignItems: "center"
                  }}
                >
                  <Avatar
                    src={
                      !this.state.profilePic
                        ? "data:image/png;base64,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"
                        : TAXI_IMAGE_URL + this.state.profilePic
                    }
                    style={{ width: 60, height: 60, objectFit: "cover" }}
                  />
                </Grid>
                <Grid
                  item
                  md={7}
                  style={{
                    display: "flex",
                    alignItems: "left",
                    flexDirection: "column",

                    justifyContent: "center"
                  }}
                >
                  <Typography
                    gutterBottom
                    style={{
                      paddingTop: PADDING.SM,
                      fontWeight: "bold",
                      fontSize: "1rem"
                    }}
                  >
                    {this.state.name}
                  </Typography>

                  <Typography variant="caption" gutterBottom>
                    {this.state.email}
                  </Typography>
                </Grid>

                <Grid item md={2}>
                  <IconButton onClick={this.handleClick}>
                    <Icon> more_horiz</Icon>
                  </IconButton>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                  >
                    <Link
                      to={USER_ROUTES.PROFILE}
                      style={{ textDecoration: "none" }}
                    >
                      <MenuItem onClick={this.handleClose}>
                        {LanguageManager.Strings.USER_MENU_OPTION1}
                      </MenuItem>
                    </Link>
                    {/* <Link
                    to={USER_ROUTES.MY_ACCOUNT}
                    style={{ textDecoration: "none" }}>
                <MenuItem onClick={this.handleClose}>{LanguageManager.Strings.USER_MENU_OPTION2}</MenuItem>
                </Link> */}

                    <MenuItem
                      onClick={() =>
                        this.setState({ isLogout: true }, () =>
                          this.props.logoutCallBack(this.state.isLogout)
                        )
                      }
                    >
                      {LanguageManager.Strings.USER_MENU_OPTION3}
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
              <Divider />
              <Link
                to={{
                  pathname: "/user_profile",
                  state: {
                    fromNotifications: true
                  }
                }}
                style={{ textDecoration: "none" }}
              >
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> person</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION1}
                  />
                </ListItem>
              </Link>
              <Link to={"/user_booking"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> local_taxi</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION2}
                  />
                </ListItem>
              </Link>
              <Link to={"/user_trips"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> history </Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION3}
                  />
                </ListItem>
              </Link>
              {/* <Link to={"/fav_driver"} style={{ textDecoration: "none" }}>
            <ListItem button key="2">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Favourite Driver" />
            </ListItem>
          </Link> */}
              <Link to={"/user_wallet"} style={{ textDecoration: "none" }}>
                <ListItem button key="2">
                  <ListItemIcon>
                    <Icon> account_balance_wallet </Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={LanguageManager.Strings.USER_DRAWER_OPTION4}
                  />
                </ListItem>
              </Link>

              <Divider />
              <Grid style={{ padding: 20, textAlign: "left" }}>
                <Typography style={{}}>Refer and Earn : </Typography>
                <Typography style={{ fontWeight: 600, color: "green" }}>
                  {" "}
                  {this.state.referalCode}
                </Typography>
              </Grid>
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>{this.props.children}</main>
      </div>
    );
  }
}

export default withStyles(UserBookingStyles, { withTheme: true })(UserLayout);
